<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="270px"
    custom-class="wxLink"
    :append-to-body="true"
    @touchmove.native.prevent
    :close-on-click-modal="false"
  >
    <div class="Box">
      <span class="title">{{ title }}</span>
      <span class="content" v-if="agreement"
        >请您认真阅读<span style="color: #f67942" @click="open(91)"
          >《用户服务协议》</span
        >和<span style="color: #f67942" @click="open(86)">《隐私政策》</span
        >的全部条款，接受后可开始使用我们的服务</span
      >
      <span class="content" v-else>{{ content }}</span>
      <div class="timeBox" v-if="!isCancel">
        退出登录时间：{{ forgetText }}
      </div>
      <div class="btBox" :class="!isCancel ? 'btBox2' : ''">
        <fm-button
          class="h5Bt"
          type="primary"
          round
          size="medium"
          @click="submit"
          >{{ submitText }}</fm-button
        >
        <fm-button
          v-if="isCancel"
          class="h5Bt2"
          type="info"
          round
          plain
          size="medium"
          @click="handleClose"
          >{{ cancelText }}</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'wxLink',
  props: {
    //打开关闭
    isShow: {
      type: Boolean,
      default: false,
    },
    //标题
    title: {
      type: String,
      default: '获取链接',
    },
    //内容
    content: {
      type: String,
      default: '链接需前往 Feemoo APP看视频获取',
    },
    //是否需要协议
    agreement: {
      type: Boolean,
      default: false,
    },
    //确认按钮文字
    submitText: {
      type: String,
      default: '立即前往',
    },
    //关闭按钮文字
    cancelText: {
      type: String,
      default: '取消',
    },
    //是否需要关闭按钮
    isCancel: {
      type: Boolean,
      default: true,
    },
    forgetText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    open(num) {
      // window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      // window.open(url, '_href')
      if(this.detectBrowser()){
        let url = this.$glb.shareUrl + '/agreement/?code=' + num
        //曲线救国，如果不设置窗口名，浏览器会限制只能开一个窗口
        const windowName = 'wxLink' + new Date().getTime();
        window.open(url, windowName);
      }else{
        window.location.href = this.$glb.shareUrl + '/agreement/?code=' + num
      }
    },
    // 兼容主流浏览器 safari Chrome Firefox
    detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : '';
      
      // 检测Safari
      const isSafari =
        vendor.includes('apple') &&
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') &&
        !userAgent.includes('fxios');
      
      // 检测Chrome（包括移动版Chrome）
      const isChrome =
        (userAgent.includes('chrome') || userAgent.includes('crios')) &&
        // 排除Edge浏览器（因为Edge的UA也可能包含chrome）
        !userAgent.includes('edg') &&
        !userAgent.includes('edge');
      
      // 检测Firefox（包括移动版Firefox）
      const isFirefox = 
        userAgent.includes('firefox') || 
        userAgent.includes('fxios');
      
      // 如果是其中任意一种浏览器则返回true
      return isSafari || isChrome || isFirefox;
    },
    //提交方法
    submit: _.debounce(
      async function () {
        this.$emit('submit')
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleClose() {
      this.$emit('handleClose')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .wxLink {
  border-radius: 24px !important;
  background: #fafafa;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  width: 287px !important;
  transform: translate(-50%, -50%);
  .el-dialog__body {
    padding: 0 !important;
    text-align: center;
    .Box {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 16px;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2c;
        line-height: 24px;
        margin-bottom: 14px;
      }
      .content {
        font-weight: 400;
        font-size: 12px;
        color: #2c2c2c;
        line-height: 18px;
      }
      .timeBox {
        background: #f3f5f7;
        border-radius: 8px;
        font-weight: 400;
        font-size: 10px;
        color: #8a8b92;
        line-height: 14px;
        padding: 10px 12px;
        width: 100%;
        margin-top: 12px;
      }
      .btBox {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .h5Bt {
          width: 108px;
          height: 39px;
        }
        .h5Bt2 {
          width: 108px;
          height: 39px;
          margin-left: 10px;
        }
      }
      .btBox2 {
        width: 100% !important;
        .h5Bt {
          width: 100% !important;
        }
      }
    }
  }
}
</style>
